import { itixUserController } from '@x-com/pwitixcomm/tslib/itix.user.ts'

const WISHLIST_STORAGE_KEY = 'plt_pending_wishlist'

export const getPendingWishlist = (): string[] => {
    try {
        return JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY) ?? '[]')
    } catch {
        return []
    }
}

export const clearPendingWishlist = () => {
    localStorage.removeItem(WISHLIST_STORAGE_KEY)
}

const addToPendingWishlist = (showId: string) => {
    const pending = getPendingWishlist()
    if (!pending.includes(showId)) {
        pending.push(showId)
        localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(pending))
    }
}

export const initWishlist = () => {
    (async () => {
        document.querySelector('body')?.addEventListener('user-wishlist-loaded', async (e: CustomEvent) => {
            if (e.detail.status !== 'OK') {
                return
            }

            const wishList = e.detail.message.wishlist

            document.querySelectorAll(`[data-favorites-show]`).forEach((el) => el.classList.remove('active'))

            wishList.forEach((item: any) => {
                document.querySelector(`[data-favorites-show="${item.show}"]`)?.classList.add('active')
            })
        })

        document.querySelectorAll('[data-favorites-show]').forEach((el) =>
            el.addEventListener('click', async (e) => {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()

                const btn = e.currentTarget as HTMLElement
                const showId = btn.dataset.favoritesShow
                const favourites_dialog = document.getElementById('favourites_dialog') as HTMLDialogElement | null

                if (showId) {
                    const formData = new FormData()
                    formData.set('showId', showId)

                    if (btn.classList.contains('active')) {
                        const data = await itixUserController.removeWishList(formData)

                        if (data.status === 'OK') {
                            btn.classList.remove('active')
                            await itixUserController.getWishList()
                        } else {
                            favourites_dialog?.showModal()
                        }
                    } else {
                        const data = await itixUserController.addWishList(formData)

                        if (data.status === 'OK') {
                            btn.classList.add('active')
                            await itixUserController.getWishList()
                        } else {
                            addToPendingWishlist(showId)
                            favourites_dialog?.showModal()
                        }
                    }
                }
            })
        )

        await itixUserController.getWishList()
    })()
}
